module.exports = __webpack_public_path__ + "fonts/NotoSansKR-R.ecf7c76.woff";